// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
//Stageing API: https://ci-api-staging.borderlessaccess.com/api/v1/
//Local API: http://localhost:3000/api/v1/

export const environment = {
  production: false, 
  //apiURL: "http://localhost:3000/api/v1/", // Use this for Local API
  //apiURL: "https://ci-api-staging.borderlessaccess.com/api/v1/", // Use this for Stage API
  apiURL: "https://ci-api.borderlessaccess.com/api/v1/", // Use this for PROD API
  ImagePath : "https://ci.borderlessaccess.com/",
  //ImagePath : "http://localhost:4200/",
  CommentsMaxLimit: 20
};
